<template>
	<router-view />
	<img id="h-logo-img" alt="" src="../src/assets/image/shining3d-logo.png" style="display: none" />
	<xl-cookies v-if="!is3dViewer" :langs="store.state.langs" :bgImg="$importImg('cookies.png')" :iconImg="$importImg('theTriangle.svg')" @openPrivacyPolicy="openPrivacyPolicy"></xl-cookies>
	<privacy-policy ref="privacyPolicyRef" key="privacy"></privacy-policy>
	<privacy-policy type="termsOfUse" title="home.termsofuseText" ref="termsOfUseRef" key="termsOfUse"></privacy-policy>
	<privacy-policy type="developerProtocol" source="sdkCloud" title="home.developerProtocol" ref="developerProtocolRef" key="developerProtocol"></privacy-policy>
	<privacy-policy type="applicationSpecification" source="sdkCloud" title="home.applicationSpecification" ref="applicationSpecificationRef" key="applicationSpecification"></privacy-policy>
	<privacy-policy type="dockingAgreements" source="sdkCloud" title="home.dockingAgreements" ref="dockingAgreementsRef" key="dockingAgreements"></privacy-policy>
	<updateLog ref="updateLogRef" :showLogo="false" />
</template>
<script setup>
import { $getCountry, $getInfo, $privacyUpdate, $importImg } from '@/assets/common/common.js';
import privacyPolicy from '@/components/pricacy/index.vue';
import updateLog from '@/components/cheader/updateLog.vue';
import { useGetFactoryList } from '@/hooks/useGetFactoryList.js';
import { lowVersionOfTheTip, XLCookies as XlCookies, loadAliyunCaptchaNew } from '@shining3d/xl-login';
import * as _ from 'lodash';
import { useIdleLogout } from '@/hooks/useIdleLogout';
import { VueCookieNext } from 'vue-cookie-next';
import { useStore } from 'vuex';
import { getNoParseCountryCode } from '@shining3d/common-module/utils/libphonenumber.js';
import httpService from '@/utils/httpService.js';
import { useRoute } from 'vue-router';
const store = useStore();
const route = useRoute();
const is3dViewer = ref( true );

watch(
	() => route.fullPath,
	() => {
		if ( !route.fullPath.includes( '3dViewer' )) {
			nextTick(() => {
				is3dViewer.value = false;
			});
		}
	}
);

lowVersionOfTheTip();
loadAliyunCaptchaNew();
// 语言存储
store.commit( 'setI18n', window.app.i18n || {});
// ETCD存储
store.commit( 'setGlobal', window.app.global || {});

// 获取国家码
$getCountry();
if ( VueCookieNext.getCookie( 'token' )) {
	// 获取用户信息
	$getInfo().then(() => {
		// 判断是否版本更新
		$privacyUpdate();
	});
}
const privacyPolicySwitch = computed(() => store.state.privacyPolicySwitch );
const termsOfUseSwitch = computed(() => store.state.termsOfUseSwitch );
const developerProtocol = computed(() => store.state.developerProtocol );
const dockingAgreements = computed(() => store.state.dockingAgreements );
const applicationSpecification = computed(() => store.state.applicationSpecification );
const privacyPolicyRef = ref( null );
const termsOfUseRef = ref( null );
const developerProtocolRef = ref( null );
const applicationSpecificationRef = ref( null );
const dockingAgreementsRef = ref( null );
// 展示隐私协议
const privacyPolicyChange = () => {
	privacyPolicyRef.value.getInfo();
	privacyPolicyRef.value.dialogVisible = true;
};
// 展示用户协议
const termsOfUseChange = () => {
	termsOfUseRef.value.getInfo();
	termsOfUseRef.value.dialogVisible = true;
};
// 展示
const developerProtocolChange = () => {
	developerProtocolRef.value.getInfo();
	developerProtocolRef.value.dialogVisible = true;
};
// 展示
const dockingAgreementsChange = () => {
	dockingAgreementsRef.value.getInfo();
	dockingAgreementsRef.value.dialogVisible = true;
};
const applicationSpecificationChange = () => {
	applicationSpecificationRef.value.getInfo();
	applicationSpecificationRef.value.dialogVisible = true;
};
const pChange = _.throttle(
	() => {
		privacyPolicyChange();
	},
	2000,
	{ leading: true, trailing: false }
);
// 监听隐私协议
watch( privacyPolicySwitch, () => {
	pChange();
});
// 监听用户协议
watch( termsOfUseSwitch, () => {
	tChange();
});

const tChange = _.throttle(
	() => {
		termsOfUseChange();
	},
	2000,
	{ leading: true, trailing: false }
);

const dChange = _.throttle(
	() => {
		developerProtocolChange();
	},
	2000,
	{ leading: true, trailing: false }
);

watch( developerProtocol, () => {
	dChange();
});

const aChange = _.throttle(
	() => {
		applicationSpecificationChange();
	},
	2000,
	{ leading: true, trailing: false }
);

watch( applicationSpecification, () => {
	aChange();
});

const daChange = _.throttle(
	() => {
		dockingAgreementsChange();
	},
	2000,
	{ leading: true, trailing: false }
);

watch( dockingAgreements, () => {
	daChange();
});

const token = VueCookieNext.getCookie( 'token' );
if ( token ) {
	useGetFactoryList({ store, reload: false });
}

const { initIdle, updateIdleStatus } = useIdleLogout();

const updateLogRef = ref();
onMounted(() => {
	if ( token ) {
		updateLogRef.value.getAnnouncement( 'announcement' );
	}
	// 添加ico文件
	const logoIco = document.getElementById( 'h-logo-img' ).src;
	const icoLink = document.getElementById( 'p-logo-icon' );
	if ( icoLink ) {
		icoLink.href = logoIco;
	}
	getNoParseCountryCode( httpService, true );
	initIdle();
	window.$idleLogout = { updateIdleStatus };
});
</script>
<style lang="scss">
@use '@/assets/common/common.scss' as *;
#app {
	position: relative;
	height: 100vh;
	overflow: auto;
	display: flex;
	flex-direction: column;
	// min-width: 1200px;
}
/* 清除默认的内外边距 /
/ 内减模型:盒子的边框与边距不会影响盒子的大小 */
body,
input,
img,
div,
ul,
li,
a,
span,
i,
p,
h1,
h2,
h3,
h4,
h5,
h6,
strong,
ins,
em,
del {
	margin: 0;
	padding: 0;
}
html,
body {
	height: 100%;
	font-family: $font-family;
	-webkit-font-smoothing: antialiased;
	color: $color-n10;
}

/* 清除a标签的下划线和字体颜色 */
a {
	text-decoration: none;
}

div {
	box-sizing: border-box;
}

/* 清除li标签前的小点点 */
li {
	// list-style: none;
}

/* 清除input标签的边框线和外轮廓线 */
input {
	border: none;
	outline: none;
}

/* 清除img标签在地基浏览器中的自带边框 /
/ 控制文字与图片的中线对齐 */
img {
	border: none;
	vertical-align: middle;
}

/* 调整浏览器的默认字体大小为12px /
/ 设置 容器高度=字体大小 */
body {
	line-height: $line-height;
}
</style>
